<script setup lang="ts">
import TinyUserThumb from "@/components/TinyUserThumb.vue";

type Props = {
  optionText: string;
  percentage: number;
  isMyVote?: boolean;
  voters?: string[];
};

const {
  optionText,
  percentage,
  isMyVote = false,
  voters = [],
} = defineProps<Props>();
</script>

<template>
  <div class="flex flex-col gap-1">
    <div
      class="relative overflow-hidden rounded-sm border-2 border-kekkle-dark bg-gray-50 dark:bg-kekkle-dark"
    >
      <!-- Result Bar -->
      <div
        class="absolute top-0 left-0 h-full bg-kekkle-yellow opacity-40 transition-all duration-500 dark:opacity-60"
        :style="{ width: percentage + '%' }"
      ></div>

      <div class="relative flex items-center justify-between px-3 py-2">
        <span class="text-sm font-medium text-kekkle-dark dark:text-slate-200">
          {{ optionText }}
          <span v-if="isMyVote" class="ml-1 text-sm">✅</span>
        </span>
        <span class="text-sm font-bold text-kekkle-dark dark:text-slate-200"
          >{{ percentage }}%</span
        >
      </div>
    </div>

    <!-- Voters list -->
    <div
      v-if="voters && voters.length > 0"
      class="flex flex-wrap items-center gap-1.5 px-1"
    >
      <TinyUserThumb
        v-for="uuid in voters"
        :key="uuid"
        :uuid="uuid"
        class="-mr-1 -ml-1 origin-left scale-[0.8]"
      />
    </div>
  </div>
</template>
